import { reactive } from 'vue';
import { defineStore } from 'pinia';
import createFeatureAxios from '@/libs/featureAxios';
import { AccessFailure, getAccessFailure } from '@/utils/featureErrors';
import eventBus from '@/eventBus/eventBus';

export type PaidFeature = 'crm' | 'automations';
type AccessState = AccessFailure | 'checking' | 'allowed';

export default defineStore('paidAccess', () => {
  const states = reactive<Record<PaidFeature, AccessState>>({ crm: 'checking', automations: 'checking' });
  const revisions = { crm: 0, automations: 0 };
  const client = createFeatureAxios();

  function reportError(feature: PaidFeature, error: unknown) {
    const failure = getAccessFailure(error);
    if (failure) {
      revisions[feature] += 1;
      states[feature] = failure;
    }
  }

  async function check(feature: PaidFeature): Promise<boolean> {
    revisions[feature] += 1;
    const revision = revisions[feature];
    states[feature] = 'checking';
    try {
      await client.get('/session/subscription');
      if (revision !== revisions[feature]) return false;
      states[feature] = 'allowed';
      return true;
    } catch (error) {
      if (revision === revisions[feature]) states[feature] = getAccessFailure(error) || 'unavailable';
      return false;
    }
  }

  eventBus.on('event:logout', () => {
    (['crm', 'automations'] as const).forEach((feature) => {
      revisions[feature] += 1;
      states[feature] = 'checking';
    });
  });
  return { states, check, reportError };
});
